module.exports = function(obj){
  return Object.prototype.toString.call(obj) === '[object Array]';
};


//////////////////
// WEBPACK FOOTER
// ./~/sprite-anim/src/utils/is-array.js
// module id = 43
// module chunks = 0